import React, { useState, useEffect } from "react";
import { PDFDownloadLink } from "@react-pdf/renderer";
import { CgSpinner } from "react-icons/cg";
import CostPlusContract from "../contractPdf/CostPlusContract";
import LoadingWithLable from "../../../../../ReusableComponents/Loading/LoadingWithLable";

const GenerateCostPlusPDFPopup = ({
  openGenerateQuotation,
  setOpenGenerateQuotation,
  list,
}) => {
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  console.log(list, "list");
  // return <p>hello</p>;
  const HEADERS_DATA = list?.contract_cost_sheet_headings;
  const HEADERS_LENGTH = HEADERS_DATA.length;
  const BASIC_INFO = list?.contract_cost_sheet_profession_basic_information;
  const COST_DETAILS = list?.contract_cost_sheet_cost_details;

  const jobPositions = list?.job_possition;
  const visaProfessions = list?.visa_profession;
  const professionalLevels = list?.profession_level;
  const nationaity = list?.nationality;

  let empHeaders = [
    "Quotation ID",
    "Actual Profession",
    "Visa Profession",
    "Profession Level",
    "Gender",
    "Nationality",
    "Quantity",
  ]; // these are fixed columns
  let fixedHeadersCount = empHeaders.length;
  const headers = [];
  const data = [];
  console.log(BASIC_INFO, "basic info");
  for (let i = 0; i < BASIC_INFO.length; i++) {
    let profession = professionalLevels.find(
      (data) => data.id == BASIC_INFO[i]?.profession_level_id
    );
    let item = {
      contract_cost_sheet_profession_basic_information_id: BASIC_INFO[i].id,
      quotation_id: BASIC_INFO[i]?.quotation_id,
      actual_profession: jobPositions.find(
        (data) => data.id == BASIC_INFO[i]?.job_position_id
      )?.name,
      visa_profession: visaProfessions.find(
        (data) => data.id == BASIC_INFO[i]?.visa_profession_id
      )?.name,
      profession_Level: professionalLevels.find(
        (data) => data.id == BASIC_INFO[i]?.profession_level_id
      )?.name,
      gender: BASIC_INFO[i]?.gender,
      nationality: nationaity.find(
        (data) => data.id == BASIC_INFO[i]?.nationality_id
      )?.name,
      quantity: BASIC_INFO[i]?.quantity,
      "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)":
        parseInt(profession?.admin_fee) +
        parseInt(profession?.nitakat) +
        parseInt(profession?.soundline_fee),
    };
    data.push(item);
  }

  const result = [];
  const rateCategoryMap = {};
  HEADERS_DATA.forEach((heading) => {
    rateCategoryMap[heading.id] = heading?.rate_category?.name;
  });

  COST_DETAILS.forEach((costDetail) => {
    const {
      contract_cost_sheet_profession_basic_information_id,
      contract_cost_sheet_heading_id,
      cost,
    } = costDetail;
    const head = HEADERS_DATA.find(
      (heading) => heading.id === contract_cost_sheet_heading_id
    );
    let heading;
    if (head?.type === "Default") {
      heading = head?.rate_category_item?.name;
    } else {
      heading = head?.rate_category_item_name;
    }
    const rateCategory = rateCategoryMap[contract_cost_sheet_heading_id];
    let professionEntry = result.find(
      (entry) =>
        entry.contract_cost_sheet_profession_basic_information_id ===
        contract_cost_sheet_profession_basic_information_id
    );
    if (!professionEntry) {
      professionEntry = {
        contract_cost_sheet_profession_basic_information_id,
        data: [],
      };
      result.push(professionEntry);
    }

    professionEntry.data.push({
      heading,
      cost,
      rate_category: rateCategory,
    });
  });

  for (let i = 0; i < HEADERS_LENGTH; i++) {
    const qcs = HEADERS_DATA[i];
    let head =
      qcs.type === "Default"
        ? qcs.rate_category_item?.name
        : qcs.rate_category_item_name;
    let rateCategory = qcs?.rate_category?.name;

    if (rateCategory === "Employee Salary Package") {
      if (!empHeaders.includes(head)) empHeaders.push(head);
    }
  }
  headers.push(...[...empHeaders]);

  const combinedData = data.map((item1) => {
    const item2 = result.find(
      (item) =>
        item.contract_cost_sheet_profession_basic_information_id ===
        item1.contract_cost_sheet_profession_basic_information_id
    );

    if (item2) {
      return {
        ...item1,
        data: item2.data,
      };
    } else {
      return item1;
    }
  });

  combinedData.forEach((item) => {
    // Extract the data array from the current item
    const data = item?.data;

    // Initialize a variable to store the total cost
    let totalCost = 0;

    // Iterate through the data array and sum the costs
    data?.forEach((dataItem) => {
      // Convert the cost to a number and add it to the totalCost
      totalCost += parseFloat(dataItem?.cost);
    });

    // Create a new object for the "TOTAL MONTHLY CHARGES (SAR)"
    const totalMonthlyCost = {
      heading: "TOTAL MONTHLY CHARGES (SAR)",
      cost: Number(totalCost).toFixed(2), // Round to 2 decimal places
      rate_category: "Employee Salary Package",
    };

    // Push the totalMonthlyCost object to the data array
    data?.push(totalMonthlyCost);
  });

  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////
  ///////////////////////////////////////////////////////////

  const [disableCheckbox, setDisableCheckbox] = useState(false);
  const [onChangeValue, setOnchangeValue] = useState({ obj: {}, value: "" });
  const [FEES_PAYABLE, SET_FEES_PAYABLE] = useState([]);
  const [MUQEEM_POINTS, SET_MUQEEM_POINTS] = useState([]);

  const [costPlusHeadings, setCostPlusHeadings] = useState([
    {
      col: "ACTUAL PROFESSION",
      title: "actual_profession",
      basic: true,
    },
    {
      col: "VISA PROFESSION",
      title: "visa_profession",
      basic: true,
    },
    {
      col: "PROFESSION LEVEL",
      title: "profession_Level",
      basic: true,
    },
    {
      col: "GENDER",
      title: "gender",
      basic: true,
    },
    {
      col: "NATIONALITY",
      title: "nationality",
      basic: true,
    },
    {
      col: "QUANTITY",
      title: "quantity",
      basic: true,
    },
    {
      col: "Salary",
      title: "Salary",
    },
    {
      col: "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
      title:
        "Monthly Fee (each) (including NItakat, Admin and SL Service Fee) (SAR)",
    },
  ]);
  console.log(costPlusHeadings, "costplusheading");
  const [GenerateList, setGenerateList] = useState([
    ...costPlusHeadings,
    {
      col: "TOTAL MONTHLY CHARGES (SAR)",
      title: "TOTAL MONTHLY CHARGES (SAR)",
    },
  ]);

  useEffect(() => {
    const costPlusHeadingArray = costPlusHeadings.map((detail) =>
      String(detail.title).toLowerCase()
    );
    const CPcostSheetHeadings = list?.contract_cost_sheet_headings?.map(
      (heading) => {
        return {
          col: heading.rate_category_item_name,
          title: heading.rate_category_item_name,
        };
      }
    );

    // // Filter out duplicates based on the 'col' property
    const uniqueCPcostSheetHeadings = CPcostSheetHeadings.filter(
      (heading, index, self) =>
        index ===
        self.findIndex(
          (h) =>
            h.col === heading.col &&
            !costPlusHeadingArray.includes(String(h.col).toLowerCase())
        )
    );
    console.log(uniqueCPcostSheetHeadings, "unique");

    setCostPlusHeadings([
      ...costPlusHeadings,
      ...uniqueCPcostSheetHeadings,
      { col: "TOTAL MONTHLY CHARGES (SAR)", title: "total_monthly_charges" },
    ]);

    // SET_FEES_PAYABLE(list?.quotation_fees_payable);
    // SET_MUQEEM_POINTS(list?.quotation_muqeem_point);
  }, [list]);

  useEffect(() => {
    const name = onChangeValue.obg?.col;
    const value = onChangeValue.value;
    if (GenerateList.length >= 9 && value === true) {
      setDisableCheckbox(true);
      const filteredArray = GenerateList.filter((item) => item?.col !== name);
      setGenerateList(filteredArray);
    } else {
      setDisableCheckbox(false);
      if (value === true) {
        setGenerateList((prev) => [...prev, onChangeValue.obg]);
      } else {
        const filteredArray = GenerateList.filter((item) => item?.col !== name);
        setGenerateList(filteredArray);
      }
    }
  }, [onChangeValue]);

  const OnChangeHandler = (value, item) => {
    setOnchangeValue({ obg: item, value: value });
  };

  console.log(combinedData, "combinded data");

  return (
    <div
      className={`fixed z-50 top-0 left-0 min-w-full min-h-screen bg-black/50  justify-center items-center ${
        openGenerateQuotation ? "flex" : "hidden"
      }`}
    >
      <form className="max-w-3xl w-full h-auto bg-white  rounded-md p-5">
        <h2 className="text-lg font-bold">CHOOSE FIELDS</h2>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <p className="text-sm uppercase">select fields between 3 to 9</p>
          <p className="text-xs text-slate-600 font-semibold">
            {GenerateList.length}/9 Selected
          </p>
        </div>
        <div className="my-4 grid grid-cols-2 gap-2 uppercase">
          {costPlusHeadings?.map((item, index) => (
            <div key={index} className="form-control w-fit">
              <label className="cursor-pointer label">
                <input
                  disabled={
                    (disableCheckbox &&
                      !GenerateList.some((check) => check.col == item.col)) ||
                    item.col === "TOTAL MONTHLY CHARGES (SAR)"
                  }
                  onChange={(e) => OnChangeHandler(e.target.checked, item)}
                  type="checkbox"
                  checked={GenerateList.some(
                    (check) =>
                      check.col == item.col ||
                      item.col === "TOTAL MONTHLY CHARGES (SAR)"
                  )}
                  className="checkbox  checkbox-accent"
                  title={`${
                    item.col === "TOTAL MONTHLY CHARGES (SAR)"
                      ? "TOTAL MONTHLY CHARGES (SAR) CAN'T BE UNSELECTED"
                      : ""
                  }`}
                />
                <span className="label-text ml-2 font-semibold font-lg">
                  {item.col}
                </span>
              </label>
            </div>
          ))}
        </div>
        <div className="flex gap-3 justify-center items-center m-5">
          <button
            className="p-2 max-w-xs-ultra w-full rounded-md ring-1 ring-slate-600"
            onClick={() => {
              setOpenGenerateQuotation(false);
            }}
          >
            CANCEL
          </button>
          {list?.contract?.quotation_type?.name === "Cost Plus" &&
          GenerateList.length <= 9 &&
          GenerateList.length >= 3 ? (
            <button
              type="button"
              onClick={() =>
                setTimeout(() => {
                  setOpenGenerateQuotation(false);
                })
              }
              className="p-2 max-w-xs-ultra w-full text-center bg-blue text-white rounded-md"
            >
              <PDFDownloadLink
                document={
                  <CostPlusContract
                    contractDetails={list}
                    combinedData={combinedData}
                    generatedTitles={GenerateList}
                  />
                }
                fileName="COSTPLUS - ANNEXURE"
              >
                {({ blob, url, loading, error }) =>
                  loading ? (
                    <LoadingWithLable className={"!mt-0 text-white"} />
                  ) : (
                    "Download"
                  )
                }
              </PDFDownloadLink>
            </button>
          ) : (
            <button
              className="p-2 max-w-xs-ultra w-full bg-blue text-white rounded-md opacity-50"
              disabled
            >
              Download
            </button>
          )}
        </div>
      </form>
      {/* <PDFViewer className="w-full min-h-screen">
        <CostPlusPdf
          combinedData={combinedData}
          QUOTATION={list?.quotation}
          generatedTitles={GenerateList}
          quotationDetails={list}
          FEES_PAYABLE={FEES_PAYABLE}
          MUQEEM_POINTS={MUQEEM_POINTS}
          TERMS={list?.terms_and_condition}
        />
      </PDFViewer> */}
    </div>
  );
};

export default GenerateCostPlusPDFPopup;
